"use client";

import * as React from "react";
import cx from "clsx";
import BadgeList from "../../BadgeList";
import { useItinerarySegmentMinimalColumnWidth } from "../context";
import ItineraryBadgeListItem from "./ItineraryBadgeListItem";
import { spaceAfterClasses } from "../../common/tailwind";
import useTheme from "../../hooks/useTheme";
const ItineraryBadgeList = ({
  children,
  spaceAfter,
  ...props
}) => {
  const {
    itinerarySegmentMinimalColumnWidth: offset
  } = useItinerarySegmentMinimalColumnWidth();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement("div", {
    className: cx("orbit-itinerary-badge-list", spaceAfter && spaceAfterClasses[spaceAfter]),
    style: {
      marginInlineStart: `${2 * parseInt(theme.orbit.spaceSmall, 10) + offset}px`
    }
  }, /*#__PURE__*/React.createElement(BadgeList, props, children));
};
export default ItineraryBadgeList;
export { ItineraryBadgeListItem };